<template>
  <div id="page-user">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between">
      <h3 class="p-0">
        <b-icon class="mr-3" icon="person-square" font-scale="1.5" variant="primary"></b-icon>
        {{ $t('pages.user.title', { user: ($store.getters.userIsAdmin) ? $tc('common.user', 0) : $t('pages.user.userQuote') }) }}
      </h3>
      <div>
        <router-link
            class="btn btn-info mt-2"
            :to="{ name: 'user-create' }"
        >
          <span v-if="$store.getters.userIsAdmin">{{ $t('pages.user.createUser') }}</span>
          <span v-else>{{ $t('pages.user.createUserQuote') }}</span>
        </router-link>
      </div>
    </div>

    <hr />

    <div class="d-xl-flex justify-content-between mb-4">
      <div class="d-xl-flex mb-4 w-100">
        <div class="search mt-2 mt-md-0">
          <div class="input-group">
            <input
                type="text"
                class="form-control border"
                v-model="filter.search"
                :placeholder="$t('common.search.keyword')"
                v-on:keyup.enter="sendResearchRequest"
            />
            <b-icon class="icon-x" icon="x" font-scale="1.5" v-on:click="sendResearchRequestReset"></b-icon>
            <div class="input-group-append">
              <button class="btn btn-success p-0 pl-2 pr-2" v-on:click="sendResearchRequest">
                {{ $t('common.search.research') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    {{ /* Table component */ }}
    <div class="card table-card border-0 shadow">
      <div class="card-body p-0">
        <TableComponent
            v-if="UserModule.users.length !== 0"
            :headerList="configTableComponent.headerList"
            :datas="UserModule.users"
            :entityName="'user'"
            :actionList="configTableComponent.actionList"
            :specificAction="configTableComponent.specificAction"
            :isAction="true"
            @ordered="clickOrdered"
            @switch="handleSwitch"
            @specific-action="handleSpecificAction"
        />

        <div v-if="UserModule.users.length === 0">
          <div v-if="filter.search != null" class="text-center mt-5">
            {{ $t('pages.user.noResultList') }}
          </div>
          <div v-else class="text-center mt-5">
            {{
              $t(
                  'pages.user.noResultList',
                  { user: ($store.getters.userIsAdmin) ? $tc('common.user', 0) : $t('pages.user.userQuote') }
              )
            }}
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="d-flex justify-content-between">
          <div class="d-flex">
            <div class="filter-elem-per-page">
              <select class="form-control" v-model="filter.elemPerPage" v-on:change="changeLimitList">
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            <div class="count-elem my-auto ml-3">
              <b>{{ (filter.search) ? UserModule.totalRequest :  UserModule.total}}</b>
              {{ $t('common.result') }}
            </div>
          </div>

          <div class="d-flex">
            <vPaginate
                v-if="UserModule.users.length > 0"
                class="my-auto"
                :classes="bootstrapPaginationClasses"
                v-model="filter.page"
                :page-count="(UserModule.totalRequest > 0)
                  ? Math.ceil(UserModule.totalRequest / filter.elemPerPage)
                  : Math.ceil(UserModule.total / filter.elemPerPage)
                "
                @change="sendPaginateRequest"
            >
            </vPaginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      },
      filter: {
        page: parseInt(this.$route.query.page) || 1,
        elemPerPage: 25,
        order: {
          index: 'id',
          order: 'DESC'
        },
        search: null,
      },
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      configTableComponent: {
        headerList : [
          {'index' : 'id', 'name' : '#', 'align' : 'left', 'filter': true, 'order' : 'DESC'},
          {'index' : 'username', 'indexTrad' : 'common.username', 'align' : 'left', 'filter': true },
          {'index' : 'roles', 'name' : 'Roles', 'align' : 'center', 'filter': false },
          {'index' : 'firstname', 'indexTrad' : 'common.firstname', 'align' : 'center', 'filter': true },
          {'index' : 'lastname', 'indexTrad' : 'common.lastname', 'align' : 'center', 'filter': true },
          {'index' : 'company', 'indexTrad' : 'common.company', 'align' : 'center', 'filter': false },
          {'index' : 'lastConnection', 'indexTrad' : 'pages.user.tableList.lastConnection', 'align' : 'center', 'filter': true, 'date': true, 'datetime': false },
          {'index' : 'isActive', 'indexTrad' : 'common.active', 'align' : 'center', 'filter': false, 'switch': true }
        ],
        actionList: [
          {
            'indexTrad' : 'common.actions.see',
            'routeName' : 'user-show',
            'icon' : 'eye',
            'icon-variant': 'success',
            'params' : true,
            'link-action': true
          },
          {
            'indexTrad': 'common.actions.edit',
            'routeName' : 'user-edit',
            'icon' : 'pencil-square',
            'icon-variant': 'info',
            'params' : true ,
            'link-action': true
          },
        ],
        specificAction: [
          { 'index': 'delete', 'indexTrad' : 'common.actions.delete', 'cssClass' : 'btn-danger ml-2'}
        ]
      }
    }
  },
  created() {
    this.showLoader()

    this.$store.dispatch('fetchUsers', {
      resellerId: (this.$store.getters.userIsReseller) ? this.$store.getters.getCurrentUser.id : null,
      perPage: this.filter.elemPerPage,
      page: this.filter.page,
      order: this.filter.order,
      search: (this.filter.search) ? this.filter.search : null
    })
      .then(() => {
        this.hideLoader()
      })
      .catch(() => {
        this.hideLoader()
      })

  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
    /*----------------- SELECT LIMIT LIST ------------------*/
    changeLimitList() {
      this.showLoader()

      this.$store.dispatch('fetchUsers', {
        resellerId: (this.$store.getters.userIsReseller) ? this.$store.getters.getCurrentUser.id : null,
        perPage: this.filter.elemPerPage,
        page: this.filter.page,
        order: (this.filter.order) ? this.filter.order : null,
        search: (this.filter.search) ? this.filter.search : null
      })
          .then(() => {
            this.hideLoader()
          })
    },
    /*----------------- SEARCH ------------------*/
    /**
     * Reset research
     */
    sendResearchRequestReset()
    {
      this.showLoader()

      // Reset
      this.filter.search = null

      this.$store.dispatch('fetchUsers', {
        resellerId: (this.$store.getters.userIsReseller) ? this.$store.getters.getCurrentUser.id : null,
        perPage: this.filter.elemPerPage,
        page: this.filter.page,
        order: (this.filter.order) ? this.filter.order : null,
        search: null
      })
          .then(() => {
            this.hideLoader()
          })
    },
    /**
     * Send request for research
     */
    sendResearchRequest()
    {
      this.showLoader()

      this.$store.dispatch('fetchUsers', {
        resellerId: (this.$store.getters.userIsReseller) ? this.$store.getters.getCurrentUser.id : null,
        perPage: this.filter.elemPerPage,
        page: 1,
        order: (this.filter.order) ? this.filter.order : null,
        search: (this.filter.search) ? this.filter.search : null
      })
          .then(() => {
            this.hideLoader()
          })
    },
    /*----------------- PAGINATE ------------------*/
    /**
     * Send request for paginate
     */
    sendPaginateRequest()
    {
      this.showLoader()

      this.$store.dispatch('fetchUsers', {
        resellerId: (this.$store.getters.userIsReseller) ? this.$store.getters.getCurrentUser.id : null,
        perPage: this.filter.elemPerPage,
        page: this.filter.page,
        order: (this.filter.order) ? this.filter.order : null,
        search: (this.filter.search) ? this.filter.search : null
      })
          .then(() => {
            this.hideLoader()
          })
    },
    /*----------------- ORDER ------------------*/
    /**
     * Send request for order
     * @param order
     */
    clickOrdered(order)
    {
      this.showLoader()

      this.filter.order = order

      this.$store.dispatch('fetchUsers', {
        resellerId: (this.$store.getters.userIsReseller) ? this.$store.getters.getCurrentUser.id : null,
        perPage: this.filter.elemPerPage,
        page: this.filter.page,
        order: order,
        search: (this.filter.search) ? this.filter.search : null
      })
          .then(() => {
            this.hideLoader()
          })
    },
    /*----------------- SWITCH / SPECIFIC ACTION ------------------*/
    /**
     * Handle switch (emit from table component)
     */
    handleSwitch(obj) {
      // Get user
      let user = this.$store.getters.getUserById(obj.id)

      // Security
      if(!user) {
        this.$bvToast.toast(this.$t('pages.user.toast.userNotFound'), {
          title: this.$t('common.error').toUpperCase() + ' !',
          variant: 'danger',
          solid: true
        })
      }

      // Update is Active
      user.isActive = obj.value

      // Loader
      this.showLoader()

      // Call API
      this.$store.dispatch('updateIsActiveUser', { id: user.id, user: user })
          .then(() => {
            this.hideLoader()

            this.$bvToast.toast((user.isActive) ? this.$t('pages.user.toast.userActive') : this.$t('pages.user.toast.userDisabled'), {
              title: this.$t('pages.user.toast.editSuccess'),
              variant: (user.isActive) ? 'success' : 'warning',
              solid: true
            })
          })
          .catch(() => {
            this.hideLoader()
          })
    },

    /**
     * handle specific action (emit from table component)
     *
     * @param obj
     */
    handleSpecificAction(obj) {
      // Delete
      if(obj.action === 'delete') {
        this.specificActionDelete(obj)
      }
    },
    specificActionDelete(obj) {
      this.$swal({
        title: this.$t('pages.user.toast.wantDelete'),
        text: this.$t('common.actionIrreversible'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#fa5c7c',
        cancelButtonColor: '#929292',
        confirmButtonText: this.$t('common.actions.delete')
      }).then((result) => {

        if (result.value) {
          this.showLoader()

          this.$store.dispatch('deleteUser', {id: obj.id})
            .then(() => {
              this.$bvToast.toast(this.$t('pages.user.toast.deleteSuccess'), {
                title: this.$t('pages.user.toast.delete'),
                variant: 'success',
                solid: true
              })

              this.$store.dispatch('fetchUsers', {
                resellerId: (this.$store.getters.userIsReseller) ? this.$store.getters.getCurrentUser.id : null,
                perPage: this.filter.elemPerPage,
                page: this.filter.page,
                order: this.filter.order,
                search: (this.filter.search) ? this.filter.search : null
              })

              this.hideLoader()
            })
            .catch(() => {
              this.hideLoader()

              this.$bvToast.toast(this.$t('pages.user.toast.errorDelete'), {
                title: this.$t('pages.user.toast.errorDeleteTitle'),
                variant: 'warning',
                solid: true
              })
            })
        }
      })
    }
  },
  computed: {
    ...mapState(['UserModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay'),
    TableComponent: () => import('@/components/_shared/tableComponent'),
    vPaginate: () => import('vue-plain-pagination')
  }
}
</script>

<style scoped>

</style>
